export default "__VITE_ASSET__DrQ2Z7eQ__"